import { connect } from 'react-redux';
import ChangeBalanceModal from "./ChangeBalanceModal";
import { getTranslation } from "../../../reducers/common/localization";
import { fetchChangeOrgBalance } from "../../../reducers/organization/organizations";
import { getActiveModal, hideModal, MODAL_CHANGE_ORG_BALANCE } from "../../../reducers/common/activeModal";
import { getCurrenciesData } from "../../../reducers/finance/currencies";

const mapStateToProps = (state) => {
    return {
        isOpen: getActiveModal(state).modalKey === MODAL_CHANGE_ORG_BALANCE,
        currenciesData: getCurrenciesData(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onChangeBalance: (id, data) => {
            dispatch(fetchChangeOrgBalance(id, data));
        },
        onCancel: () => {
            dispatch(hideModal());
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeBalanceModal);



// WEBPACK FOOTER //
// ./src/components/organizationManagement/changeBalanceModal/ChangeBalanceModal.container.js